import { render, staticRenderFns } from "./mawbDetails.vue?vue&type=template&id=c0d82d5e&scoped=true&"
import script from "./mawbDetails.vue?vue&type=script&lang=js&"
export * from "./mawbDetails.vue?vue&type=script&lang=js&"
import style0 from "./mawbDetails.vue?vue&type=style&index=0&id=c0d82d5e&scoped=true&lang=css&"
import style1 from "./mawbDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d82d5e",
  null
  
)

export default component.exports